/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_SchedulingInputs */

const en_lessons_scheduling = /** @type {(inputs: Lessons_SchedulingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduling...`)
};

const he_lessons_scheduling = /** @type {(inputs: Lessons_SchedulingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתזמן...`)
};

/**
* | output |
* | --- |
* | "Scheduling..." |
*
* @param {Lessons_SchedulingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_scheduling = /** @type {((inputs?: Lessons_SchedulingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_SchedulingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_scheduling(inputs)
	return he_lessons_scheduling(inputs)
});